import { render, staticRenderFns } from "./PlayerEquipment.vue?vue&type=template&id=4294958c&"
import script from "./PlayerEquipment.vue?vue&type=script&lang=js&"
export * from "./PlayerEquipment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports